import styled, { css } from 'styled-components'

const Container = styled.section`
  margin-bottom: 30px;
  float: left;
  clear: left;

  ${props =>
    props.type === 'desktop' &&
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        display: none;
      }
    `}

  ${props =>
    props.type === 'mobile' &&
    css`
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        display: none;
      }
    `}
`

const List = styled.ul`
  list-style-type: disc;
  padding-left: 17px;
  margin: 10px 0;
`

export { Container, List }
